import { API_BASE, apiFetch } from "@/lib/api-client";
import type { BrandingConfig } from "@/lib/branding";

// GET /api/tenant/branding -- what this workspace's app should render right now.
// `palette: null` means ORAI's own palette; `logo_path` is a path on the API, not a URL.
export interface TenantBranding {
  custom_branding_enabled: boolean;
  source: "platform" | "tenant";
  brand_name: string;
  /** The name the workspace itself saved, or null -- never ORAI's name filled in for it. */
  custom_brand_name: string | null;
  logo_path: string | null;
  palette: BrandingConfig | null;
}

export interface BrandingPatch {
  brand_name?: string | null;
  palette?: BrandingConfig | null;
}

export function fetchTenantBranding(): Promise<TenantBranding> {
  return apiFetch<TenantBranding>("/api/tenant/branding");
}

export function patchTenantBranding(body: BrandingPatch): Promise<TenantBranding> {
  return apiFetch<TenantBranding>("/api/tenant/branding", { method: "PATCH", body });
}

export function resetTenantBranding(): Promise<TenantBranding> {
  return apiFetch<TenantBranding>("/api/tenant/branding", { method: "DELETE" });
}

export function uploadTenantLogo(file: File): Promise<TenantBranding> {
  const form = new FormData();
  form.append("file", file);
  return apiFetch<TenantBranding>("/api/tenant/branding/logo", { method: "POST", body: form });
}

/** The logo's full URL. The server hands back a PATH so it never has to know its own host. */
export function logoUrl(logoPath: string | null | undefined): string | null {
  return logoPath ? `${API_BASE}${logoPath}` : null;
}

// PATCH /api/admin/tenants/{workspace_id}/branding-access -- a platform admin's toggle.
export function setBrandingAccess(workspaceId: string, enabled: boolean): Promise<TenantBranding> {
  return apiFetch<TenantBranding>(
    `/api/admin/tenants/${encodeURIComponent(workspaceId)}/branding-access`,
    { method: "PATCH", body: { enabled } },
  );
}
